import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import { bindAll } from 'mojito/utils';
import BettingSettings from 'modules/betting-settings/index.js';
import { connect } from 'react-redux';

const {
    selectors: { selectBetslipSettings },
} = MojitoServices.Betslip;
const { AbsolutePane, Button, Image, Popup, FlexPane } = MojitoPresentation.Components;

class BetslipSettings extends MojitoCore.Presentation.UIViewImplementation {
    constructor(...args) {
        super(...args);

        this.state = {
            showSettingsPopup: false,
        };

        bindAll(this, ['togglePopupVisibility', 'onSettingsButtonClicked']);
    }

    togglePopupVisibility(value) {
        this.setState(({ showSettingsPopup }) => ({
            showSettingsPopup: value === undefined ? !showSettingsPopup : value,
        }));
    }

    onSettingsButtonClicked() {
        this.props.onOpenCallback();
        this.togglePopupVisibility();
    }

    renderHighlightedSettingsIndicator() {
        const { higher, lower } = this.props.priceChangeAcceptance;
        return higher || lower ? (
            <AbsolutePane
                config={this.config.highlightedSettingsIndicator}
                class="ta-BetslipSettings-highlighted"
            />
        ) : null;
    }

    render() {
        if (this.config.hide) {
            return null;
        }

        return (
            <Button
                config={this.config.popupToggleButton}
                onClick={this.onSettingsButtonClicked}
                class="ta-BetslipSettings-toggle_button"
            >
                <FlexPane
                    config={this.config.popupToggleButtonIconContainer}
                    class="ta-BetslipSettingsIconContainer"
                >
                    <Image
                        config={this.config.popupToggleButtonIcon}
                        class="ta-BetslipSettingsIcon"
                    />
                    {this.renderHighlightedSettingsIndicator()}
                </FlexPane>
                {this.state.showSettingsPopup && (
                    <Popup
                        visible={this.state.showSettingsPopup}
                        config={this.config.popup}
                        captureOutsideClicks={true}
                        class="ta-BetslipSettingsPopup"
                    >
                        <BettingSettings />
                    </Popup>
                )}
            </Button>
        );
    }
}

BetslipSettings.getStyle = config => config.style;

const mapStateToProps = state => ({
    priceChangeAcceptance: selectBetslipSettings(state)?.priceChangeAcceptance,
});

export default connect(mapStateToProps)(BetslipSettings);
